import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../promotions.service';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-video-config',
  templateUrl: './video-config.component.html',
  styleUrls: ['./video-config.component.scss']
})
export class VideoConfigComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  searchValue: string;
  rowSelection
  rowData
  columnDefs
  private gridApi;
  private gridColumnApi;
  selectedRows: any;
  showUpdateRetailer: boolean;
  bannerId:any;
  constructor(private promotionService: PromotionsService, private router: Router) {
    super();
    this.getAllBannersData()
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  getAllBannersData() {
    this.promotionService.getVideoInstruction().subscribe(res => {
      if (res['httpcode'] == 200) {
        this.setGrid(res.data)
      }
    })
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'single';

    this.columnDefs = [
      { field: 'instructionsId', headerName: 'instructionsId', width: 0, hide: true, sort: "desc" },
      { field: '', headerName: 'Action', width: 160, checkboxSelection: true },
      { field: 'headerName', headerName: 'Video Header', width: 240 },
      { field: 'videoUrl', headerName: 'Video URL', width: 300 },
      { field: 'status', headerName: 'Status', width: 240 },
      { field: 'language', headerName: 'Language PReference', width: 240 },
      { field: 'instructionCreatdttm', headerName: 'Creation Date', width: 240,cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY');     
      } }
    ]
  }

  // On grid ready
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  managePromotion() {
   
    this.router.navigate([`features/promotions/video-config/edit-videos/${this.bannerId}`])
  }
  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows  && this.selectedRows.length > 0) {
      this.showUpdateRetailer = true;
      this.bannerId = this.selectedRows[0].instructionsId;

      return
    }
    this.showUpdateRetailer = false;
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  addPromotionConfig() {
    this.router.navigate([`features/promotions/video-config`])
  }


}

